// extracted by mini-css-extract-plugin
export default {"container":"SendJobErrorModal_container__Ezebz"};